import $ from 'jquery';
import Configuration from './configuration';
import 'slick-carousel';
import { imageListDOM } from './showroom-utilities';
import { __ } from '@wordpress/i18n';

const configureOEMPage = $('#configure-oem-container-FLP');

if (configureOEMPage.length !== 0) {
  const initial = $('.configure-main-oem').data('initial-values');
  // console.log('INITIAL: ==> ', initial);
  const $activeOptionsGroup = $('.configure-oem-group');
  const $activeCollectionGroup = $('.configure-color-oem.group-exterior_color');
  const $activeSetGroup = $('.configure-oem-group.group-exterior_color');
  const $collectionContainer = $('.showroom-gallery-container');
  const collectionData = $collectionContainer.data('collections');

  const collections = {};
  let CUR_COLLECTION = '';
  let CUR_SET = '';

  collectionData.forEach((col, index) => {
    const parentIndex = index == 0 ? true : false;

    const code = col.code;

    if (parentIndex) {
      CUR_COLLECTION = col.code;
    }

    const baseImages = col.images;
    const sets = {};

    col.interior_colors.forEach((set, index) => {
      sets[set.code] = [...baseImages, ...set.images];
      if (parentIndex && index == 0) {
        CUR_SET = set.code;
      }
    });
    collections[code] = sets;
  });

  runConfigSlider(CUR_COLLECTION, CUR_SET);

  const $DOMBase = $('.js-base');
  const $DOMTotal = $('.js-total');
  const $DOMFees = $('.js-fees');
  const $DOMOptions = $('.js-selected-options-group');
  const $DOMNext = $('.js-oem-next');

  const InitialDOM = {
    base: $DOMBase,
    total: $DOMTotal,
    fees: $DOMFees,
    options: $DOMOptions,
    next: $DOMNext,
  };

  const CONFIG = new Configuration({
    id: initial.id,
    base: initial.base,
    baseFinance: initial.baseFinance,
    baseLease: initial.baseLease,
    costs: initial.costs,
    taxes: initial.taxes,
    fees: initial.fees,
    DOM: InitialDOM,
    total: initial.total,
    financeTotal: initial.financeTotal,
    leaseTotal: initial.leaseTotal,
    options: [],
    next: initial.next,
    refNum: initial.refNum,
  });

  CONFIG.updatePayments();

  const configureSticky = $('#configure-sticky-overview');

  // Observe Sticky
  const sectionOne = document.querySelector('.configure-bottom-bar');

  const observeOptions = { threshold: 0.2 };

  const configObserver = new IntersectionObserver(function (entries, observer) {
    if (!entries[0].isIntersecting) {
      // show the sticky
      configureSticky.removeClass('inactive');
      // configureSticky.find('.collapse-link:not(.is-active)').trigger('click');
    } else {
      // hide the sticky
      configureSticky.addClass('inactive');
    }
  }, observeOptions);

  configObserver.observe(sectionOne);

  $('.OptionsAccessoriesInput').on('click', function () {
    const $input = $(this).find('input');
    const optionCode = $input.data('option-code');
    const optionType = $input.attr('name');
    handleColorSlideSelection();
    handleOptionSelection($input, optionCode, optionType);
    updateNext();
  });

  function handleOptionSelection($input, optionCode, optionType) {
    if (!optionCode) {
      console.warn(__('Option code is missing!'));
      return;
    }
    let newCosts = 0;
    const newOptions = [];

    // check exterior color change
    if (optionType == 'exterior-colors') {
      const cost = $input.data('msrp');
      if (cost != 0) {
        newCosts = newCosts + cost;
        newOptions.push({ id: $input.data('option-code'), primary_name: $input.data('label'), msrp: cost });
      }
    }
    // check all remaining is-active groups and their selected options inputs
    $activeOptionsGroup.each(function () {
      const $group = $(this);
      if ($group.hasClass('is-active')) {
        $(this)
          .find('.OptionInput')
          .each(function () {
            $input = $(this);
            if ($input.prop('checked')) {
              const cost = $input.data('msrp');
              if (cost != 0) {
                newCosts = newCosts + cost;
                newOptions.push({ id: $input.data('option-code'), primary_name: $input.data('label'), msrp: cost });
              }
            }
          });
      }
    });

    CONFIG.updateOptions(newOptions).updateCosts(newCosts);
    CONFIG.updateTotal().updatePayments();
    CONFIG.updateDOM().updateDOMOptions();
  }

  function handleColorSlideSelection() {
    const codes = updatedColorCodes();
    // console.log('codes: ', codes);

    if (codes) {
      runConfigSlider(codes.collection, codes.set);
    } else {
      return false;
    }
  }

  // returns object with colleciton and set
  function updatedColorCodes() {
    let hasChanged = false;
    let collectionID = CUR_COLLECTION;
    let setID = CUR_SET;

    // EXTERIOR COLOR
    $activeCollectionGroup.each(function () {
      let $color = $(this);
      let $input = $color.find('.OptionColorInput');
      if ($input.prop('checked')) {
        collectionID = $input.data('option-code');
        if (collectionID != CUR_COLLECTION) {
          hasChanged = true;
          CUR_COLLECTION = collectionID;
          // console.log('COLLECTION ==> ', collectionID);
        }
      }
    });

    // OTHER OPTIONS
    $activeSetGroup.each(function () {
      let $group = $(this);
      if ($group.hasClass('is-active')) {
        $group.find('.OptionInput').each(function () {
          let $input = $(this);
          if ($input.prop('checked')) {
            // console.log($input);
            setID = $input.data('option-code');
            if (setID != CUR_SET) {
              hasChanged = true;
              CUR_SET = setID;
              // console.log('SET ==> ', setID);
            }
          }
        });
      }
    });

    // console.log(hasChanged, setID, collectionID);
    return hasChanged ? { collection: collectionID, set: setID } : false;
  }

  // handles updating 
  function updateNext() {
    const newNext = `/build/summary/${CONFIG.id}?selected_options[]=${CUR_COLLECTION}&selected_options[]=${CUR_SET}&refNum=${CONFIG.refNum}`;
    CONFIG.updateNext(newNext).updateDOMNext();
  }

  function runConfigSlider(collection, set) {

    let sliderID = collection + '-' + set;

    $('.collection-oem-slider').each(function() {
      $(this).removeClass('is-active');
    })

    $('.collection-oem-controls').each(function() {
      $(this).removeClass('is-active');
    })

    const $configureGallerySlider = $(`.slider-${sliderID}`);


    if (!$configureGallerySlider.hasClass('slick-initialized')) {
      const images = collections[collection][set];

      $configureGallerySlider.empty();

      images.forEach((img, index) => {
        $configureGallerySlider.append(imageListDOM({ src: img }, index, sliderID));
      });

      $configureGallerySlider.on('init', function (event, slick) {
        if (slick.$dots) {
          const dots = slick.$dots.find('li');
          const theme = $(`.controls-dots-${sliderID}`).data('theme');
          dots.addClass('slick-dot ' + theme);
        }
      });

      $configureGallerySlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        adaptiveHeight: true,
        appendDots: $(`.controls-dots-${sliderID}`),
        nextArrow: $(`.controls-next-${sliderID}`),
        prevArrow: $(`.controls-prev-${sliderID}`),
      });

    } 
    
    $configureGallerySlider.on('setPosition', function (e, slick) {
      slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });

    $configureGallerySlider.addClass('is-active');
    $(`.controls-${sliderID}`).addClass('is-active');
 
  }
}
